import AdviceGeneratorApp from "./components/AdviceGeneratorApp";

function App() {
  return (
    <AdviceGeneratorApp />
  );
}

export default App;
